import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import UploadIcon from "@mui/icons-material/Upload";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import PlaceIcon from "@mui/icons-material/Place";
import {
  Typography,
  Box,
  Button,
  MenuItem,
  Chip,
  Tooltip,
  Paper,
  Stack,
  InputAdornment,
  Radio,
  RadioGroup,
  FormControl,
  Alert,
} from "@mui/material";
import { connect } from "react-redux";
import {
  PlatformMainInput,
  MainTextArea,
  main_button,
  reject_button,
} from "../../app/components/Styles";
import { useNavigate, useParams } from "react-router-dom";
import ReactFileReader from "react-file-reader";
import { createEvent } from "../../app/store/actions/eventActions";
import { getWhatsappTemplates } from "../../app/store/actions/adminActions";
import moment from "moment";
import { uploadFile } from "../../core/aws";
import {
  WhatsappEventTemplatePicker,
  resolveWhatsappTemplateField,
} from "./WhatsappEventTemplatePickers";
import {
  marketingFormHeaderSx,
  marketingFormTitleSx,
  marketingFormSubtitleSx,
} from "../../app/components/tickitMarketingTheme";
import {
  platformCardSx,
  platformFonts,
  platformFormSectionSx,
  platformPrimaryButtonSx,
  platformGhostButtonSx,
} from "../../app/components/tickitPlatformTheme";
import {
  PlatformPage,
  PlatformPageHeader,
  PlatformLoadingBlock,
} from "../../app/components/platform";

const sectionHeadingSx = {
  fontFamily: platformFonts.display,
  fontWeight: 700,
  fontSize: "0.95rem",
  mb: 1.5,
  color: "var(--platform-text)",
};

const checkboxLabelSx = {
  fontFamily: platformFonts.body,
  fontSize: "0.9rem",
  color: "var(--platform-text-2)",
};

const platformOutlinedBtnSx = { ...platformGhostButtonSx, borderWidth: 1.5 };

const chipSx = {
  color: "var(--platform-brand-light)",
  bgcolor: "var(--platform-brand-pale)",
  border: "1px solid var(--platform-border-2)",
};

export const CreateEvent = ({ createEvent, getWhatsappTemplates, templates, isLoading }) => {
  window.Buffer = window.Buffer || require("buffer").Buffer;

  const navigate = useNavigate();
  const [file, setFile] = React.useState(null);
  const id = useParams().id;

  const [extraInfo, setExtraInfo] = React.useState(0);
  const [categories, setCategories] = React.useState(1);
  const [image, setImage] = React.useState(null);
  const [coverImage, setCoverImage] = React.useState(null);
  const [sponsorsImage, setSponsorsImage] = React.useState(null);
  const [attachment, setAttachment] = React.useState(null);
  const [chart, setChart] = React.useState(null);
  const [paymentMethod, setPaymentMethod] = React.useState("None");
  const [corporate, setCorporate] = React.useState(false);
  const [byRequest, setByRequest] = React.useState(false);
  const [directInvitation, setDirectInvitation] = React.useState(false);
  const [autoAccept, setAutoAccept] = React.useState(false);
  const [isPublic, setIsPublic] = React.useState(false);
  const [hasAttachment, setHasAttachment] = React.useState(false);
  const [waRsvp, setWaRsvp] = React.useState({ sel: "", custom: "" });
  const [waQr, setWaQr] = React.useState({ sel: "", custom: "" });
  const [waPlusOne, setWaPlusOne] = React.useState({ sel: "", custom: "" });
  const [waReminder, setWaReminder] = React.useState({ sel: "", custom: "" });
  const [waRejection, setWaRejection] = React.useState({ sel: "", custom: "" });
  const [waAttachment, setWaAttachment] = React.useState({ sel: "", custom: "" });

  React.useEffect(() => {
    getWhatsappTemplates && getWhatsappTemplates({ page: 1, limit: 100, search: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePaymentMethod = (event) => {
    const value = event.target.value;
    setPaymentMethod(value);
    if (value === "Cash" || value === "InstaPay") {
      setByRequest(true);
      setCorporate(false);
    }
  };

  const ticketFlow = corporate
    ? "invitation"
    : directInvitation
    ? "directInvitation"
    : byRequest
    ? "registration"
    : "direct";

  const handleTicketFlowChange = (event) => {
    const flow = event.target.value;
    if (flow === "direct") {
      setByRequest(false);
      setCorporate(false);
      setDirectInvitation(false);
    } else if (flow === "registration") {
      setByRequest(true);
      setCorporate(false);
      setDirectInvitation(false);
    } else if (flow === "invitation") {
      setByRequest(false);
      setCorporate(true);
      setDirectInvitation(false);
    } else if (flow === "directInvitation") {
      setByRequest(false);
      setCorporate(false);
      setDirectInvitation(true);
    }
  };

  const handleAdd = (event) => {
    setExtraInfo(extraInfo + 1);
  };

  const handleRemove = (event) => {
    if (extraInfo > 0) {
      setExtraInfo(extraInfo - 1);
    }
  };

  const handleAddCat = (event) => {
    setCategories(categories + 1);
  };

  const handleRemoveCat = (event) => {
    if (categories > 1) {
      setCategories(categories - 1);
    }
  };

  const handleAddImage = (files) => {
    let file = files[0];
    console.log(file);
    setImage(file);
  };

  const handleDeleteImage = () => {
    setImage(null);
  };

  const handleAddCoverImage = (files) => {
    let file = files[0];
    console.log(file);
    setCoverImage(file);
  };

  const handleDeleteCoverImage = () => {
    setCoverImage(null);
  };

  const handleAddSponsorsImage = (files) => {
    let file = files[0];
    console.log(file);
    setSponsorsImage(file);
  };

  const handleDeleteSponsorsImage = () => {
    setSponsorsImage(null);
  };

  const handleAddAttachment = (files) => {
    let file = files[0];
    console.log(file);
    setAttachment(file);
  };

  const handleDeleteAttachment = () => {
    setAttachment(null);
  };

  const handleAddChart = (files) => {
    let file = files[0];
    console.log(file);
    setChart(file);
  };

  const handleDeleteChart = () => {
    setChart(null);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    try {
      var imageUrl;
      var coverImageUrl;
      var sponsorsImageUrl;
      var chartUrl;
      var attachmentUrl;
      var categoriesList = [];
      var moreInfo = [];
      isLoading = true;
      if (image) {
        imageUrl = await uploadFile(image);
      }
      if (coverImage) {
        coverImageUrl = await uploadFile(coverImage);
      }
      if (sponsorsImage) {
        sponsorsImageUrl = await uploadFile(sponsorsImage);
      }
      if (attachment) {
        attachmentUrl = await uploadFile(attachment);
      }
      if (chart) {
        chartUrl = await uploadFile(chart);
      }
      isLoading = false
      for (let i = 0; i < extraInfo; i++) {
        moreInfo.push(data.get(`req${i}`));
      }
      for (let i = 0; i < categories; i++) {
        categoriesList.push({
          category: data.get(`cat${i}`),
          price: parseInt(data.get(`cat${i}Price`)),
          amount: parseInt(data.get(`cat${i}Tickets`)),
          sold: 0,
          available: true,
        });
      }

      const creation = {
        image: imageUrl,
        coverImage: coverImageUrl,
        sponsorsImage: sponsorsImageUrl,
        title: data.get("title"),
        description: data.get("description"),
        terms: data.get("terms"),
        artist: data.get("artist"),
        date: moment(data.get("date")),
        location: data.get("location"),
        seatChart: chartUrl,
        categories: categoriesList,
        deadline: data.get("deadline")
          ? moment(data.get("deadline"))
          : undefined,
        public: isPublic,
        moreInfo: moreInfo,
        needsVerification: data.get("needsVerification") === "on",
        byRequest: byRequest,
        autoAccept: byRequest ? autoAccept : false,
        directInvitation: directInvitation,
        gatesOpenAt: moment(data.get("gatesOpenAt")),
        locationURL: data.get("locationURL"),
        organizer: data.get("organizer"),
        message: data.get("message"),
        corporate: corporate,
        hasAttachment: hasAttachment,
        attachmentTitle: data.get("attachmentTitle"),
        attachment: attachmentUrl,
        paymentMethod,
        paymentAddress:
          paymentMethod === "Cash"
            ? data.get("paymentAddress").split(",")
            : data.get("paymentAddress"),
      };

      if (corporate) {
        creation.whatsappRSVPTemplate = resolveWhatsappTemplateField(waRsvp.sel, waRsvp.custom);
        creation.whatsappQRTemplate = resolveWhatsappTemplateField(waQr.sel, waQr.custom);
        creation.whatsappPlusOneTemplate = resolveWhatsappTemplateField(waPlusOne.sel, waPlusOne.custom);
        creation.whatsappReminderTemplate = resolveWhatsappTemplateField(waReminder.sel, waReminder.custom);
        creation.whatsappRejectionResponseTemplate = resolveWhatsappTemplateField(waRejection.sel, waRejection.custom);
        creation.whatsappAttachmentTemplate = hasAttachment
          ? resolveWhatsappTemplateField(waAttachment.sel, waAttachment.custom)
          : null;
      } else {
        creation.whatsappRSVPTemplate = null;
        creation.whatsappQRTemplate = null;
        creation.whatsappPlusOneTemplate = null;
        creation.whatsappReminderTemplate = null;
        creation.whatsappRejectionResponseTemplate = null;
        creation.whatsappAttachmentTemplate = null;
      }

      createEvent({ creation: creation }, navigate);
    } catch (err) {
      console.log(err);
    }
  };

  const generateRequirements = () => {
    var items = [];
    for (let i = 0; i < extraInfo; i++) {
      items.push(
        <Grid item xs={12} key={`req${i}`}>
          <PlatformMainInput
            required
            fullWidth
            id={`req${i}`}
            label="Requirement"
            name={`req${i}`}
            placeholder="e.g. Instagram handle"
          />
        </Grid>
      );
    }
    return items;
  };

  const generateCategories = () => {
    var items = [];
    for (let i = 0; i < categories; i++) {
      items.push(
        <Grid item xs={12} key={`cat${i}`}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <PlatformMainInput
                required
                fullWidth
                id={`cat${i}`}
                label="Category"
                name={`cat${i}`}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <PlatformMainInput
                required
                type="number"
                fullWidth
                id={`cat${i}Price`}
                label="Price (EGP)"
                name={`cat${i}Price`}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <PlatformMainInput
                required
                type="number"
                fullWidth
                id={`cat${i}Tickets`}
                label="Number of tickets"
                name={`cat${i}Tickets`}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    }
    return items;
  };

  if (isLoading) {
    return (
      <PlatformPage maxWidth="md">
        <PlatformLoadingBlock />
      </PlatformPage>
    );
  }

  return (
    <PlatformPage maxWidth="md">
      <PlatformPageHeader
        title="Create event"
        subtitle="Set up ticketing, categories, payments, and optional WhatsApp invitations."
      />

      <Paper elevation={0} sx={{ ...platformCardSx, overflow: "hidden", p: 0 }}>
        <Box sx={marketingFormHeaderSx}>
          <Typography sx={marketingFormTitleSx}>New event</Typography>
          <Typography sx={marketingFormSubtitleSx}>
            Complete the form below — you can edit details anytime from the event dashboard.
          </Typography>
        </Box>

        <Box component="form" onSubmit={handleSubmit} sx={{ p: { xs: 2.5, sm: 4 }, bgcolor: "var(--platform-surface)" }}>
          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <Box sx={platformFormSectionSx}>
                <Typography sx={sectionHeadingSx}>Event images</Typography>
                <Stack spacing={1.5}>
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ xs: "stretch", sm: "center" }}>
                    <ReactFileReader multipleFiles={false} handleFiles={handleAddImage} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                      <Button sx={{ ...platformOutlinedBtnSx, width: "100%" }} fullWidth><UploadIcon sx={{ mr: 0.5 }} /> Event image</Button>
                    </ReactFileReader>
                    {image && <Chip label={image.name} onDelete={handleDeleteImage} sx={chipSx} />}
                  </Stack>
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ xs: "stretch", sm: "center" }}>
                    <ReactFileReader multipleFiles={false} handleFiles={handleAddCoverImage} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                      <Button sx={{ ...platformOutlinedBtnSx, width: "100%" }} fullWidth><UploadIcon sx={{ mr: 0.5 }} /> Cover image</Button>
                    </ReactFileReader>
                    {coverImage && <Chip label={coverImage.name} onDelete={handleDeleteCoverImage} sx={chipSx} />}
                  </Stack>
                  <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ xs: "stretch", sm: "center" }}>
                    <ReactFileReader multipleFiles={false} handleFiles={handleAddSponsorsImage} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                      <Button sx={{ ...platformOutlinedBtnSx, width: "100%" }} fullWidth><UploadIcon sx={{ mr: 0.5 }} /> Sponsors image</Button>
                    </ReactFileReader>
                    {sponsorsImage && <Chip label={sponsorsImage.name} onDelete={handleDeleteSponsorsImage} sx={chipSx} />}
                  </Stack>
                </Stack>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <PlatformMainInput
                required
                fullWidth
                id="title"
                label="Event title"
                name="title"
                placeholder="e.g. Nour & Karim — Wedding reception"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventAvailableIcon sx={{ color: "var(--platform-brand-light)", fontSize: 22 }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <MainTextArea
                required
                fullWidth
                multiline
                minRows={4}
                name="description"
                label="Event description"
                id="description"
                placeholder="What should guests know? Dress code, agenda, ticketing notes…"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <PlatformMainInput fullWidth id="artist" label="Artist or host" name="artist" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <PlatformMainInput
                type="datetime-local"
                required
                fullWidth
                id="date"
                label="Event date & time"
                name="date"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <PlatformMainInput
                type="datetime-local"
                fullWidth
                id="deadline"
                label="Purchase deadline"
                name="deadline"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <PlatformMainInput
                type="datetime-local"
                required
                fullWidth
                id="gatesOpenAt"
                label="Gates open"
                name="gatesOpenAt"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <PlatformMainInput
                required
                fullWidth
                id="location"
                label="Venue / location"
                name="location"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PlaceIcon sx={{ color: "var(--platform-brand-light)", fontSize: 22 }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <PlatformMainInput
                fullWidth
                type="url"
                id="locationURL"
                label="Google Maps link"
                name="locationURL"
                placeholder="https://maps.google.com/..."
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={platformFormSectionSx}>
                <Typography sx={sectionHeadingSx}>Additional requirements</Typography>
                <Typography sx={{ fontFamily: platformFonts.body, fontSize: "0.85rem", color: "var(--platform-text-2)", mb: 1.5 }}>
                  Extra fields guests fill in when purchasing tickets (e.g. Instagram link).
                </Typography>
                <Grid container spacing={2}>
                  {generateRequirements()}
                </Grid>
                <Stack direction="row" spacing={1} sx={{ mt: extraInfo > 0 ? 1.5 : 0 }}>
                  <Tooltip title="Additional data entry requirements when purchasing tickets">
                    <Button sx={{ ...main_button }} onClick={handleAdd}>Add requirement</Button>
                  </Tooltip>
                  {extraInfo > 0 && (
                    <Button sx={{ ...reject_button }} onClick={handleRemove}>Remove last</Button>
                  )}
                </Stack>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={platformFormSectionSx}>
                <Typography sx={sectionHeadingSx}>Seating & categories</Typography>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ xs: "stretch", sm: "center" }} sx={{ mb: 2 }}>
                  <ReactFileReader multipleFiles={false} handleFiles={handleAddChart} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                    <Button sx={{ ...platformOutlinedBtnSx, width: "100%" }} fullWidth><UploadIcon sx={{ mr: 0.5 }} /> Seating chart</Button>
                  </ReactFileReader>
                  {chart && <Chip label={chart.name} onDelete={handleDeleteChart} sx={chipSx} />}
                </Stack>
                <Grid container spacing={2}>
                  {generateCategories()}
                </Grid>
                <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
                  <Button sx={platformOutlinedBtnSx} onClick={handleAddCat}>Add category</Button>
                  {categories > 1 && (
                    <Button sx={{ ...reject_button }} onClick={handleRemoveCat}>Remove last</Button>
                  )}
                </Stack>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <MainTextArea required minRows={4} fullWidth name="terms" label="Terms and conditions" id="terms" />
            </Grid>

            <Grid item xs={12}>
              <Box sx={platformFormSectionSx}>
                <Typography sx={sectionHeadingSx}>Payment</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <PlatformMainInput
                      fullWidth
                      select
                      labelId="payment-method-label"
                      id="paymentMethod"
                      label="Payment method"
                      defaultValue="None"
                      name="paymentMethod"
                      onChange={handlePaymentMethod}
                    >
                      <MenuItem value="Cash">Cash</MenuItem>
                      <MenuItem value="InstaPay">InstaPay</MenuItem>
                      <MenuItem value="FawryPay">FawryPay</MenuItem>
                      <MenuItem value="Paymob">Paymob</MenuItem>
                      <MenuItem value="None">None</MenuItem>
                    </PlatformMainInput>
                  </Grid>
                  {(paymentMethod === "InstaPay" || paymentMethod === "Cash") && (
                    <Grid item xs={12}>
                      <PlatformMainInput
                        required
                        fullWidth
                        type="text"
                        id="paymentAddress"
                        label="Payment details (InstaPay address / phone numbers)"
                        name="paymentAddress"
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={platformFormSectionSx}>
                <Typography sx={sectionHeadingSx}>How guests get tickets</Typography>
                <FormControl component="fieldset" fullWidth sx={{ mb: 2 }}>
                  <RadioGroup value={ticketFlow} onChange={handleTicketFlowChange}>
                    <FormControlLabel
                      value="direct"
                      control={<Radio sx={{ color: "var(--platform-brand-light)" }} />}
                      label={
                        <Typography sx={checkboxLabelSx}>
                          Direct purchase — add to cart or pay online
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="registration"
                      control={<Radio sx={{ color: "var(--platform-brand-light)" }} />}
                      label={
                        <Typography sx={checkboxLabelSx}>
                          Registration — guests submit a request (optional auto-approve)
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="directInvitation"
                      control={<Radio sx={{ color: "var(--platform-brand-light)" }} />}
                      label={
                        <Typography sx={checkboxLabelSx}>
                          Direct invitation — send tickets to guests by email
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="invitation"
                      control={<Radio sx={{ color: "var(--platform-brand-light)" }} />}
                      label={
                        <Typography sx={checkboxLabelSx}>
                          WhatsApp invitation — corporate RSVP flow
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </FormControl>
                {byRequest && (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={autoAccept}
                          onChange={(e) => setAutoAccept(e.target.checked)}
                          sx={{ color: "var(--platform-brand-light)" }}
                        />
                      }
                      label={
                        <Typography sx={checkboxLabelSx}>
                          Auto-approve registrations
                          {paymentMethod === "None"
                            ? " (free — ticket emailed immediately)"
                            : " (paid — guest proceeds to payment after approval)"}
                        </Typography>
                      }
                    />
                    <Alert severity="info" sx={{ mb: 2, mt: 1 }}>
                    After creating the event, open the event dashboard → <strong>Registration Page</strong> to
                    customize a shareable link. The event does not need to be public in the marketplace to use
                    that link.
                  </Alert>
                  </>
                )}
                {directInvitation && (
                  <Alert severity="info" sx={{ mb: 2 }}>
                    After creating the event, use <strong>Send tickets by email</strong> on the event dashboard
                    to deliver tickets directly to your guest list.
                  </Alert>
                )}
                <Typography sx={{ ...sectionHeadingSx, fontSize: "0.85rem", mb: 1 }}>Other settings</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isPublic}
                      onChange={(e) => setIsPublic(e.target.checked)}
                      name="public"
                      id="public"
                      sx={{ color: "var(--platform-brand-light)" }}
                    />
                  }
                  label={<Typography sx={checkboxLabelSx}>List as a public event (marketplace / browse)</Typography>}
                />
                <Tooltip title="Ushers verify ticket holder name or ID before entry">
                  <FormControlLabel
                    control={<Checkbox name="needsVerification" id="needsVerification" sx={{ color: "var(--platform-brand-light)" }} />}
                    label={<Typography sx={checkboxLabelSx}>Needs verification at the gate</Typography>}
                  />
                </Tooltip>
              </Box>
            </Grid>

            {corporate && (
              <Grid item xs={12}>
                <Box sx={platformFormSectionSx}>
                  <Typography sx={sectionHeadingSx}>WhatsApp invitation</Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <PlatformMainInput fullWidth id="organizer" label="Organized by" name="organizer" />
                    </Grid>
                    <Grid item xs={12}>
                      <MainTextArea fullWidth required minRows={4} inputProps={{ maxlength: 512 }} name="message" label="WhatsApp message (512 characters max)" id="message" />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={<Checkbox checked={hasAttachment} onChange={() => setHasAttachment(!hasAttachment)} name="hasAttachment" id="hasAttachment" sx={{ color: "var(--platform-brand-light)" }} />}
                        label={<Typography sx={checkboxLabelSx}>Include attachment message</Typography>}
                      />
                    </Grid>
                  </Grid>

                  <Typography sx={{ ...sectionHeadingSx, mt: 2.5 }}>WhatsApp templates (Meta names)</Typography>
                  <Typography variant="body2" sx={{ color: "var(--platform-text-2)", fontFamily: platformFonts.body, mb: 2 }}>
                    Choose an approved template from the list, enter a custom template name, or leave each as default (none).
                  </Typography>
                  <Stack spacing={2}>
                    <WhatsappEventTemplatePicker label="RSVP invitation template" value={waRsvp} onChange={setWaRsvp} templates={templates} />
                    <WhatsappEventTemplatePicker label="QR / ticket template" value={waQr} onChange={setWaQr} templates={templates} />
                    <WhatsappEventTemplatePicker label="Plus one template" value={waPlusOne} onChange={setWaPlusOne} templates={templates} />
                    <WhatsappEventTemplatePicker label="Reminder template" value={waReminder} onChange={setWaReminder} templates={templates} />
                    <WhatsappEventTemplatePicker label="Rejection response template" value={waRejection} onChange={setWaRejection} templates={templates} />
                  </Stack>

                  {hasAttachment && (
                    <Box sx={{ mt: 2.5 }}>
                      <Typography sx={sectionHeadingSx}>Attachment WhatsApp message</Typography>
                      <Typography variant="body2" sx={{ color: "var(--platform-text-2)", fontFamily: platformFonts.body, mb: 2 }}>
                        Sent after the ticket QR when this event has an attachment.
                      </Typography>
                      <Stack spacing={2}>
                        <WhatsappEventTemplatePicker label="Attachment message template" value={waAttachment} onChange={setWaAttachment} templates={templates} />
                        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ xs: "stretch", sm: "center" }}>
                          <ReactFileReader multipleFiles={false} handleFiles={handleAddAttachment} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                            <Button sx={{ ...platformOutlinedBtnSx, width: "100%" }} fullWidth><UploadIcon sx={{ mr: 0.5 }} /> Attachment image</Button>
                          </ReactFileReader>
                          {attachment && (
                            <Chip label={attachment.name} onDelete={handleDeleteAttachment} sx={chipSx} />
                          )}
                        </Stack>
                        <PlatformMainInput fullWidth id="attachmentTitle" label="Attachment title" name="attachmentTitle" />
                      </Stack>
                    </Box>
                  )}
                </Box>
              </Grid>
            )}
          </Grid>

          <Button type="submit" fullWidth variant="contained" size="large" sx={{ ...platformPrimaryButtonSx, mt: 3, py: 1.75, fontSize: "1rem" }}>
            Create event
          </Button>
        </Box>
      </Paper>
    </PlatformPage>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  token: state?.auth?.token,
  isLoading: state?.events?.isLoading,
  templates: state?.records?.results?.templates,
});

const mapDispatchToProps = { createEvent, getWhatsappTemplates };

export default connect(mapStateToProps, mapDispatchToProps)(CreateEvent);
